var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-toggle-content.ts
import { isPrinting } from "@adornis/base/client/frontend-helpers/index.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { fromEvent } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ChemistryLitElement } from "../../chemistry-lit-element.js";
import { RXController } from "../../controllers/RXController.js";
import { event } from "../../decorators/event.js";
import { css } from "../../directives/css.js";
import "../../renderable.js";
import "../components/x-flex.js";
import "../components/x-icon.js";
import { xComponents } from "../x-components.js";
var XToggleContent = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.label = "";
    this.open = false;
    this.isPrinting = new RXController(this, isPrinting);
  }
  connectedCallback() {
    super.connectedCallback();
    fromEvent(this, "focusin").pipe(takeUntil(this.disconnected)).subscribe(() => this.open = true);
  }
  render() {
    return xComponents(html` ${this._labelWrapper()} ${this._contentWrapper()} `);
  }
  _labelWrapper() {
    return xComponents(html`
      <x-flex
        horizontal
        crossaxis-center
        space="md"
        ${css({ cursor: "pointer", userSelect: "none" })}
        @click="${() => {
      this.open = !this.open;
      if (!this.open)
        this.blur();
    }}"
      >
        ${this._label()}
      </x-flex>
    `);
  }
  _label() {
    return xComponents(
      html` ${this.icon()} ${typeof this.label === "string" ? html` <x-h4> ${this.label} </x-h4> ` : this.label} `
    );
  }
  _contentWrapper() {
    return xComponents(html`
      <x-flex
        id="content"
        ${css({
      marginLeft: `calc(${this.spacing.md} + 20px)`,
      ...this.open ? { height: "unset", paddingTop: this.spacing.md, paddingBottom: this.spacing.md } : { height: "0", opacity: "0", pointerEvents: "none", overflow: "hidden" }
    })}
      >
        ${this._content()}
      </x-flex>
    `);
  }
  _content() {
    return this.content ? this.open ? this.content() : nothing : html` <slot></slot> `;
  }
  icon() {
    return xComponents(html`
      <x-icon ${css({ color: this.colors.accent, fontSize: "20px" })}>
        ${this.open || this.isPrinting.value ? "expand_more" : "chevron_right"}
      </x-icon>
    `);
  }
};
__decorateClass([
  property({ type: String })
], XToggleContent.prototype, "label", 2);
__decorateClass([
  property({ reflect: true, type: Boolean }),
  event
], XToggleContent.prototype, "open", 2);
__decorateClass([
  property({ attribute: false })
], XToggleContent.prototype, "content", 2);
__decorateClass([
  state()
], XToggleContent.prototype, "isPrinting", 2);
XToggleContent = __decorateClass([
  customElement("x-toggle-content")
], XToggleContent);
export {
  XToggleContent
};
